






























































import { Component, Mixins, Prop } from "vue-property-decorator";
import { ReceptionTabMixin } from "./mixins";
import { ButtonInfo } from "../../../../domain/workflow/items";
import { DomainRegistry } from "../../../../domain";

import ReceptionPatientView from "../../viewers/controls/ReceptionPatientView.vue";
import ReceptionInformationView from "../../viewers/controls/ReceptionInformationView.vue";
import ReceptionApplicantView from "../../viewers/controls/ReceptionApplicantView.vue";
import ReceptionRecipientView from "../../viewers/controls/ReceptionRecipientView.vue";
import ReceptionContactView from "../../viewers/controls/ReceptionContactView.vue";
import ReceptionDeliveryView from "../../viewers/controls/ReceptionDeliveryView.vue";
import ReceptionDetailView from "../../viewers/controls/ReceptionDetailView.vue";

import WorkflowActionDialog from "../../dialogs/WorkflowActionDialog.vue";
import WorkflowActionConfirmDialog from "../../dialogs/WorkflowActionConfirmDialog.vue";

@Component({
  components: {
    ReceptionPatientView,
    ReceptionInformationView,
    ReceptionApplicantView,
    ReceptionRecipientView,
    ReceptionContactView,
    ReceptionDeliveryView,
    ReceptionDetailView,
  }
})
export default class ReceptionTab extends Mixins(ReceptionTabMixin) {

  @Prop({ default: false })
  isViewMode: boolean;

  @Prop()
  workflowActionDialog: WorkflowActionDialog;

  @Prop()
  workflowActionConfirmDialog: WorkflowActionConfirmDialog;

  get isApplicantVisible(): boolean {
    return this.labelSetting ? this.labelSetting.isApplicantVisible : true;
  }
  
  get isRecipientVisible(): boolean {
    return this.labelSetting ? this.labelSetting.isRecipientVisible : true;
  }
  
  get isContactVisible(): boolean {
    return this.labelSetting ? this.labelSetting.isContactVisible : true;
  }

  get isProjectTeamVisible(): boolean {
    return this.labelSetting ? this.labelSetting.isProjectTeamVisible : true;
  }

  get isPaperNameVisible(): boolean {
    return this.labelSetting && this.labelSetting.isPaperNameVisible;
  }

  get isPaperCompanyNameVisible(): boolean {
    return this.labelSetting && this.labelSetting.isPaperCompanyNameVisible;
  }

  get isInOutTypeEnable(): boolean {
    return this.labelSetting && this.labelSetting.isInOutTypeVisible;
  }

  get isAddressTypeEnable(): boolean {
    return this.labelSetting && this.labelSetting.isAddressTypeVisible;
  }

  get isDiseaseVisible(): boolean {
    return this.labelSetting && this.labelSetting.isDiseaseVisible;
  }

  get deliveryType(): string {
    if (!this.delivery) { return ""; }
    return this.delivery.type.name;
  }
  
  // 依頼削除
  async deleteDetail(): Promise<void> {
    const repository = DomainRegistry.workflow.getWorkflowRepository();
    const editTokens = await repository.getReceptionDetailIdDocumentTokens(this.reference.receptionDetail.id);
    if (editTokens && 0 < editTokens.length) {
      const ret = await this.workflowActionConfirmDialog.show(editTokens, this.deleteDetailPermission.buttonName, this.deleteDetailPermission.confirmMessage);
      if (!ret) { return; }
    }

    const result = await this.workflowActionDialog.show({
      actionPermission: this.deleteDetailPermission,
      nextMessagePermission: this.deleteMessagePermission,
      nextMessage: "",
    });
    if (result.isConfirmed) {
      this.execDeleteDetail(result.nextMessage);
    }
  }

  // 依頼取消、依頼復活
  async confirmWorkflowAction(permission: ButtonInfo): Promise<void> {
    const repository = DomainRegistry.workflow.getWorkflowRepository();
    const editTokens = await repository.getReceptionDetailIdDocumentTokens(this.reference.receptionDetail.id);
    if (editTokens && 0 < editTokens.length) {
      const ret = await this.workflowActionConfirmDialog.show(editTokens, permission.buttonName, permission.confirmMessage);
      if (!ret) { return; }
    }

    // 依頼系の処理は伝達事項は使わない
    const confirmResult = await this.workflowActionDialog.show({
      actionPermission: permission,
    });
    if (confirmResult.isConfirmed) {
      this.doWorkflowAction(permission, null, null, null);
    }
  }
  
  async publishReceiptConfirm(): Promise<void> {
    const name = this.publishReceiptPermission.buttonName;
    const index = await this.$commonDialogs.confirmation.show({
      message: [
        name + "を行います。",
        "本当によろしいですか？",
      ],
      buttons: [
        {
          kind: "confirm",
          label: "発行する",
        },
        {
          kind: "danger",
          label: "中止する",
        },
      ],
    });
    if (index === 0) {
      this.publishReceipt();
    }
  }
}
